export default __webpack_public_path__ + "static/media/spamemail.a830d2ba.jpg";